var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-generic',_vm._b({},'modal-generic',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }